import { type EntitySyncConfigurationConstructor } from '../../entities/EntitySyncConfiguration/entitySyncConfiguration'
import { type EntitySyncConfigurationApiModel } from '../api-models/EntitySyncConfigurationApiModel'

export const mapEntitySyncConfigurationApiModelToConstructor = (
  entitySyncConfigurationApiModel: EntitySyncConfigurationApiModel
): EntitySyncConfigurationConstructor => ({
  id: entitySyncConfigurationApiModel.id,
  entity: entitySyncConfigurationApiModel.entity,
  isEnabled: entitySyncConfigurationApiModel.is_enabled,
  lastSync: entitySyncConfigurationApiModel.last_sync,
})
